import Validation from "utils/validation.utils";
import locale from "localization";

export const initialState = {
  firstName: {
    name: "firstName",
    value: "",
    placeholder: "",
    validations: [
      Validation.required({ noMessage: true }),
      Validation.name()
    ],
    required: true,
    label: locale.firstName
  },
  lastName: {
    name: "lastName",
    value: "",
    placeholder: "",
    validations: [
      Validation.required({ noMessage: true }),
      Validation.name()
    ],
    required: true,
    label: locale.lastName
  },
  email: {
    name: "email",
    placeholder: "",
    value: "",
    disabled: true,
    maxLength: 75,
    label: locale.emailAddress,
  },
  password: {
    name: "password",
    placeholder: "",
    value: "",
    maxLength: 75,
    message: locale.use8CharWithMix,
    label: locale.password,
  },
  confirmPassword: {
    name: "confirmPassword",
    placeholder: "",
    value: "",
    maxLength: 75,
    label: locale.confirmPassword,
  },
};
